import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// import { imgBaseUrl } from '../../../vite.config.js';
// console.log(imgBaseUrl);

const revealVideo = function () {

    const $introSection = $('#ASUS-features .section__intro'),
    $introBtn = $('#ASUS-features .section__intro #btn-video-intro'),
    introElement = document.getElementById('video-intro'),
    $introElementJquery = $('#ASUS-features .section__intro #video-intro');
    let introPath = {
        large: `https://dlcdnwebimgs.asus.com/files/media/27043ed5-6508-4e03-aefa-d15c5d767210/v1/videos/dock.mp4`,
        small: `https://dlcdnwebimgs.asus.com/files/media/27043ed5-6508-4e03-aefa-d15c5d767210/v1/videos/dock.mp4`
        // large: 'https://dlcdnwebimgs.asus.com/files/media/2523515c-4a57-41a5-9004-67490621ae51/v1/videos/kv.mp4',
        // small: 'https://dlcdnwebimgs.asus.com/files/media/2523515c-4a57-41a5-9004-67490621ae51/v1/videos/kv.mp4'
    };
    // const $kvSection = $('#ASUS-features .section__kv'),
    // $kvVideoBtn = $('#ASUS-features .btn-video-kv'),
    // kvVideoElement = document.getElementById('video-kv'),
    // $kvVideoElementJquery = $('#ASUS-features #video-kv');
    // let kvVideoPath = {
    //     // large: '../../videos/kv.mp4',
    //     // small: '../../videos/kv.mp4'
    //     large: 'https://dlcdnwebimgs.asus.com/files/media/2523515c-4a57-41a5-9004-67490621ae51/v1/videos/kv.mp4',
    //     small: 'https://dlcdnwebimgs.asus.com/files/media/2523515c-4a57-41a5-9004-67490621ae51/v1/videos/kv.mp4'
    // };

    function lazyLoadVideo($sectionBaseDisplay, path, videoElement, $videoElementJquery, $videoBtn, startPoint1, startPoint2) {

        // 取得當前視窗寬度
        const $videoWindow = $(window);
        // 根據視窗寬度選擇視頻源類型
        const rwdType = $videoWindow.width() >= 1025 ? 'large' : 'small';
        // 設置視頻源路徑
        const videoSrcPath = path[rwdType];
        // 創建source元素
        const source = document.createElement('source');
        // 根據視窗寬度設定滾動觸發起始點
        const startPoint = $videoWindow.width() > 735 ? startPoint1 : startPoint2;

        let $sectionBaseHeight = $sectionBaseDisplay.outerHeight();

        // 處理視頻進入事件：設置視頻源、重置播放時間並播放
        function handleVideoEnter() {
            if ($videoElementJquery.children('source').length === 0) {
                source.setAttribute('src', videoSrcPath);
                videoElement.appendChild(source);
            }
            $videoBtn.attr({
                'data-status': 'pause',
                title: 'pause'
            }).html('pause');
            videoElement.currentTime = 0;
            videoElement.play();
            
        }

        // 處理視頻離開事件：暫停播放
        function handleVideoLeave() {
            videoElement.pause();
        }


        $videoWindow.on("resize scroll", function() {
            let scrollTop = $(this).scrollTop();
            let sectionScrollerTop = $sectionBaseDisplay.offset().top;
            let sectionScrollerBottom = sectionScrollerTop + $sectionBaseDisplay.outerHeight();
            let windowHeight = $videoWindow.height();
            let inSection = false;

            // console.log(scrollTop, sectionScrollerTop - 400, sectionScrollerBottom);

            if(scrollTop > sectionScrollerTop - 400 && scrollTop < sectionScrollerBottom && inSection == false) {
                inSection = true;
                if ($videoElementJquery.children('source').length === 0) {
                    source.setAttribute('src', videoSrcPath);
                    videoElement.appendChild(source);
                    videoElement.currentTime = 0;
                }
                if (videoElement.currentTime == 0 || videoElement.paused) {
                    $videoBtn.attr({
                        'data-status': 'pause',
                        title: 'pause'
                    }).html('pause');
                    videoElement.currentTime = 0;
                    videoElement.play();
                }
            } else {
                inSection = false;
                videoElement.pause();             
            }
        });

        // 使用gsap設置滾動觸發器
        gsap.to($sectionBaseDisplay, {
            scrollTrigger: {
              trigger: $sectionBaseDisplay,
              start: startPoint,
              end: "bottom top-=200%",
              // end: `+=${$sectionBaseHeight}`,
              markers: false,
              onEnterBack: (self) => handleVideoEnter(),
              onEnter: (self) => handleVideoEnter(),
              onLeaveBack: (self) => handleVideoLeave(),
              onLeave: (self) => handleVideoLeave(),
            },
          });

        if (videoElement.paused) {
            $(this).attr({
                'data-status': 'pause',
                title: 'pause'
            }).html('pause');
            videoElement.play();
        } else {
            $(this).attr({
                'data-status': 'play',
                title: 'play'
            }).html('play');
            videoElement.pause();
        }

        // 設置視頻播放/暫停按鈕點擊事件
        $videoBtn.on('click', function () {
            // const videoStatus = $(this).attr('data-status');
        
            if (videoElement.paused) {
                $(this).attr({
                    'data-status': 'pause',
                    title: 'pause'
                }).html('pause');
                videoElement.play();
            } else {
                $(this).attr({
                    'data-status': 'play',
                    title: 'play'
                }).html('play');
                videoElement.pause();
            }
        });
    }
    lazyLoadVideo($introSection, introPath, introElement, $introElementJquery, $introBtn);

    // lazyLoadVideo($performanceSection, displayVideo04Path, displayVideo04Element, $performanceVideo04ElementJquery, $performanceVideo04Btn, 'top top', 'top top');
}
export default revealVideo;